import { render, staticRenderFns } from "./nav-item.vue?vue&type=template&id=05a0d897&scoped=true"
import script from "./nav-item.vue?vue&type=script&lang=js"
export * from "./nav-item.vue?vue&type=script&lang=js"
import style0 from "./nav-item.vue?vue&type=style&index=0&id=05a0d897&prod&lang=scss&scoped=true"
import style1 from "./nav-item.vue?vue&type=style&index=1&id=05a0d897&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0d897",
  null
  
)

export default component.exports